interface FieldProps {
  label: string;
  value?: string | number | null;
  mono?: boolean;
}

/** Read-only label + value pair (copy of lcaSupplier's `Field`): renders "—" for an empty/whitespace-only value. */
const Field = ({ label, value, mono }: FieldProps) => {
  const text = value == null ? "" : String(value);
  return (
    <div className="tw-space-y-1">
      <p className="tw-text-[10px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-muted-foreground">
        {label}
      </p>
      <p
        className={`tw-whitespace-pre-line tw-text-sm tw-text-foreground ${
          mono ? "tw-font-mono" : ""
        }`}
      >
        {text.trim() ? text : "—"}
      </p>
    </div>
  );
};

export default Field;
